export type Kit = {
    Id: number,
    LotNumber: number,
    KitSize: string,
    KitNumber: number,
    ExpirationDate: Date,
    Used: boolean,
    Flag: boolean,
}

export function apiModelToKit(apiModel: any) {
    return {
        Id: apiModel.id,
        LotNumber: apiModel.lotNumber,
        KitSize: apiModel.kitSize,
        KitNumber: apiModel.kitNumber,
        ExpirationDate: apiModel.expirationDate,
        Used: apiModel.used,
        Flag: apiModel.flag,
    } as Kit;
}

export const blankKit = {
    Id: 0,
    LotNumber: 0,
    KitSize: 'S',
    KitNumber: 0,
    ExpirationDate: new Date(),
    Used: false,
    Flag: false,
} as Kit;

export const kitSizes = [
    { shortText: "?", text: "Unknown", id: 0 },
    { shortText: "S", text: "10-200ul", id: 1 },
    { shortText: "L", text: "201-5000ul", id: 2 },
];

export const padLotNumber = (lotNumber: string | number) => {
    return String(lotNumber).padStart(4, '0');
}
export const padKitNumber = (kitNumber: string | number) => {
    return String(kitNumber).padStart(5, '0');
}